import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useOutletContext, useLocation } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { format } from "date-fns";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { InputText } from "primereact/inputtext";
import { exportExcel } from "../hooks/useExportUtils";
import { ListBox } from "primereact/listbox";
//import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
export const IncidenciasTranferencia = ({ Auth }) => {
  const dt = useRef(null);
  const toast = useRef(null);
  const { selectedNomina } = useOutletContext();
  const [listadoFaltas, setListadoFaltas] = useState([]);
  const [nominas, setNominas] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(10);
  const [periodosDisponibles, setPeriodosDisponibles] = useState([]);
  //const [periodoSeleccionado, setPeriodoSeleccionado] = useState(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const location = useLocation();

  //console.log("selectedNomina:", selectedNomina);
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const periodoParam = queryParams.get("periodo");
    // if (periodoParam) {
    //   setPeriodoSeleccionado(periodoParam);
    // }
  }, [location.search]);

  const getData = async () => {
    try {
      const resNominas = await axiosPrivate.get("NOM/nominas");
      setNominas(resNominas.data);
      const resPeriodos = await axiosPrivate.get("NOM/periodos");
      setPeriodosDisponibles(resPeriodos.data);
    } catch (error) {
      console.error("Error al obtener faltas:", error);
    }
  };

  useEffect(() => {
    if (!selectedNomina) return;
    getData();
  }, [selectedNomina]);
  const columns = [
    { field: "numero", header: "Número", sortable: true },
    { field: "nombre", header: "Nombre", sortable: true },
    { field: "activo", header: "estado", sortable: true },
    { field: "Nomina", header: "Nomina", sortable: true },
    { field: "fechaIngreso", header: "Ingreso", sortable: true },
    { field: "fechaBaja", header: "Baja", sortable: true },
    { field: "DiasFalta", header: "Total faltas", sortable: true },
    { field: "DiasVacaciones", header: "Total vacaciones", sortable: true },
    { field: "DiasNomina", header: "Dias nomina", sortable: true },
    { field: "DiasTrabajados", header: "Asistencia", sortable: true },
    { field: "PBD", header: "PBD", sortable: true },
    { field: "valorFormula", header: "valorFormula", sortable: true },
    { field: "valorSueldo", header: "Valor sueldo", sortable: true },
    { field: "valorVacaciones", header: "Valor vacaciones", sortable: true },
  ];

  const formatFecha = (valor) => {
    if (!valor) return "";
    const fecha = new Date(valor);
    if (isNaN(fecha)) return "";

    const dia = String(fecha.getDate()).padStart(2, "0");
    const mes = String(fecha.getMonth() + 1).padStart(2, "0");
    const año = fecha.getFullYear();

    return `${dia}/${mes}/${año}`;
  };
  function parseFechaDDMMYYYY(fecha) {
    if (!fecha) return "";

    let f = fecha;

    if (typeof fecha === "string" && fecha.includes("/")) {
      const [dia, mes, año] = fecha.split("/");
      f = new Date(`${año}-${mes}-${dia}T00:00:00`);
    } else {
      f = new Date(fecha);
    }

    if (isNaN(f.getTime())) return "Fecha inválida";

    const dia = f.getDate().toString().padStart(2, "0");
    const mes = (f.getMonth() + 1).toString().padStart(2, "0");
    const año = f.getFullYear();

    return `${dia}/${mes}/${año}`;
  }
  const dynamicColumns = columns.map((col) => {
    // campos que deseas formatear como fecha
    const camposFecha = [
      "created_at",
      "updated_at",
      "fechas",
      "fechaIngreso",
      "fechaBaja",
    ];

    return (
      <Column
        key={col.field}
        field={col.field}
        header={col.header}
        sortable={col.sortable}
        body={
          camposFecha.includes(col.field)
            ? (rowData) => {
                const valor = rowData[col.field];
                // Si es un array (como fechas), formatea cada elemento
                if (Array.isArray(valor)) {
                  return valor.map((f) => parseFechaDDMMYYYY(f)).join(", ");
                }

                // Si es fecha única
                return parseFechaDDMMYYYY(valor);
              }
            : undefined
        }
      />
    );
  });
  const template2 = {
    layout: "RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink",
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 50, value: 50 },
      ];

      return (
        <>
          <span className="mx-2">Items por página:</span>
          <Dropdown
            value={options.value}
            options={dropdownOptions}
            onChange={options.onChange}
          />
        </>
      );
    },
    CurrentPageReport: (options) => (
      <span className="mx-2">
        {options.first} - {options.last} de {options.totalRecords}
      </span>
    ),
  };

  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  };
  const handleBack = () => {
    navigate(-1);
  };

  const [seleccionados, setSeleccionados] = useState([]);

  const leftToolbarTemplate = () => (
    <div className="flex gap-2 items-center flex-center">
      {/* <label htmlFor="periodo" className="whitespace-nowrap">
        Filtrar por periodo:
      </label>
      <Dropdown
        id="periodo"
        optionLabel="periodo"
        optionValue="periodo"
        value={periodoSeleccionado}
        options={periodosDisponibles}
        onChange={(e) => setPeriodoSeleccionado(e.value)}
        placeholder="Selecciona periodo"
        className="w-15rem"
        showClear
      /> */}
      <label htmlFor="periodo" className="whitespace-nowrap">
        Seleccione la nomina:
      </label>
      <ListBox
        value={seleccionados}
        options={nominas}
        id="nominas"
        onChange={(e) => setSeleccionados(e.value)}
        multiple
        optionLabel="Nomina"
        optionValue="idNomina"
        metaKeySelection={true}
        checkbox={"checkbox"}
        //filter
        style={{ width: "20rem" }}
        listStyle={{ maxHeight: "150px" }}
      />
      <Button
        label="Cargar registros"
        icon="pi pi-refresh"
        severity="secondary"
        onClick={() => CargarRegistros(seleccionados)}
      />
    </div>
  );
  const CargarRegistros = (data) => {
    const periodo = `${selectedNomina.YearPeriodo}-${selectedNomina.PeriodoActual
      .toString()
      .padStart(2, "0")}`;
    //console.log("Exportando a CargarRegistros:", data, periodo);
    if (!data || data.length === 0) {
      toast.current.show({
        severity: "warn",
        summary: "Advertencia",
        detail: "Debe seleccionar al menos una nómina",
        life: 3000,
      });
      return;
    }
    // if (!periodo) {
    //   toast.current.show({
    //     severity: "warn",
    //     summary: "Advertencia",
    //     detail: "Debe seleccionar un periodo",
    //     life: 3000,
    //   });
    //   return;
    // }

    axiosPrivate
      .post(`/NOM/incidencias/procesar`, {
        nominaIds: data,
        periodo: periodo,
        fechaFinal: selectedNomina.FechaFinal,
      })
      .then((response) => {
        const resultado = response.data
          .map((incidencia) => {
            const nomina = Auth.Parametros.Nominas.find(
              (n) => n.idNomina === incidencia.idNomina
            );

            const [dia, mes, año] = selectedNomina.FechaInicial.split("/");
            const fechaInicioPeriodo = new Date(
              Number(año),
              Number(mes) - 1,
              Number(dia)
            );

            const [diaF, mesF, añoF] = selectedNomina.FechaFinal.split("/");
            const fechaFinPeriodo = new Date(
              Number(añoF),
              Number(mesF) - 1,
              Number(diaF)
            );

            const [diaI, mesI, añoI] = incidencia.fechaIngreso.split("/");
            const fechaIngreso = new Date(
              Number(añoI),
              Number(mesI) - 1,
              Number(diaI)
            );

            let fechaBaja = null;
            if (incidencia.fechaBaja) {
              const [diaB, mesB, añoB] = incidencia.fechaBaja.split("/");
              fechaBaja = new Date(
                Number(añoB),
                Number(mesB) - 1,
                Number(diaB)
              );
            }

            const diasNomina = nomina?.DiasNomina ?? 0;

            // console.log("Datos de fechaIngreso:", fechaIngreso);
            // console.log("Datos de fechaInicioPeriodo:", fechaInicioPeriodo);
            // console.log(
            //   "Datos de incidencia:",
            //   fechaIngreso && fechaIngreso > fechaInicioPeriodo
            // );
            // 1. Calcular inicio real
            const inicioTrabajo =
              fechaIngreso && fechaIngreso > fechaInicioPeriodo
                ? fechaIngreso
                : fechaInicioPeriodo;

            //console.log("Fecha inicio periodo:", inicioTrabajo);

            // 2. Calcular fin real antes del tope
            let finTrabajo =
              fechaBaja && fechaBaja < fechaFinPeriodo
                ? fechaBaja
                : fechaFinPeriodo;

            // console.log("fechaBaja: " + fechaBaja);
            // console.log("finTrabajo: " + finTrabajo);

            // 3. Aplicar tope de días NOMINA al rango (inicioTrabajo + diasNomina - 1)
            const finMaximoPermitido = new Date(fechaInicioPeriodo);
            finMaximoPermitido.setDate(
              finMaximoPermitido.getDate() + diasNomina - 1
            );
            if (finTrabajo > finMaximoPermitido) {
              finTrabajo = finMaximoPermitido;
            }
            //
            inicioTrabajo.setHours(0, 0, 0, 0);
            finTrabajo.setHours(0, 0, 0, 0);
            // 4. Calcular días efectivos del periodo ya limitado
            const diffTime = finTrabajo.getTime() - inicioTrabajo.getTime();
            const diasPeriodoEfectivo =
              diffTime >= 0
                ? Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1
                : 0;

            const diasFaltas = incidencia.diasFaltas || 0;
            const diasVacaciones = incidencia.diasVacaciones || 0;
            const diasTotales = diasFaltas + diasVacaciones;

            //console.log("Datos calculados:" + finTrabajo);
            let diasTrabajados = diasPeriodoEfectivo - diasTotales;

            const esFebrero = Number(mes) === 2;
            const esSegundaQuincena = Number(dia) >= 16;
            if (esFebrero && esSegundaQuincena && diasTrabajados > 0 && diasTrabajados < diasNomina) {
              diasTrabajados = diasNomina-diasFaltas-diasVacaciones; // Ajustar a 28 días menos las faltas y vacaciones
            }
            // console.log("Datos esFebrero:" + esFebrero);
            // console.log("Datos esSegundaQuincena:" + esSegundaQuincena);
            // console.log("Datos diasTrabajados:" + diasTrabajados);

            if (diasTrabajados < 0) diasTrabajados = 0;
            return {
              ...incidencia,
              DiasNomina: diasNomina,
              DiasFalta: diasFaltas,
              DiasVacaciones: diasVacaciones,
              DiasTrabajados: diasTrabajados,
              Nomina: nomina?.Nomina ?? "N/A",
              inicioTrabajo: formatFecha(inicioTrabajo),
              finTrabajo: formatFecha(finTrabajo),
              fechaBaja,
              valorSueldo: (diasTrabajados * incidencia.valorFormula).toFixed(
                2
              ),
              valorVacaciones: (
                diasVacaciones * incidencia.valorFormula
              ).toFixed(2),
            };
          })
          .filter((emp) => {
            const [dia, mes, año] = selectedNomina.FechaInicial.split("/");
            const fechaInicioPeriodo = new Date(
              Number(año),
              Number(mes) - 1,
              Number(dia)
            );

            const [diaF, mesF, añoF] = selectedNomina.FechaFinal.split("/");
            const fechaFinPeriodo = new Date(
              Number(añoF),
              Number(mesF) - 1,
              Number(diaF)
            );
            let fechaBaja = null;

            if (fechaBaja && fechaBaja < fechaInicioPeriodo) return false;

            // Excluir empleados que ingresaron después del fin del periodo
            if (emp.fechaIngreso && emp.fechaIngreso > fechaFinPeriodo)
              return false;

            // Excluir empleados sin días trabajados y dados de baja
            if (emp.DiasTrabajados === 0 && emp.fechaBaja) return false;

            // Incluir el resto
            return true;
          });
        //console.log("Resultado procesado:", resultado);
        setListadoFaltas(resultado);

        toast.current.show({
          severity: "success",
          summary: "Éxito",
          detail: response.data.msg,
          life: 3000,
        });
        getData(); // Recargar datos después de la transferencia
      })
      .catch((error) => {
        setListadoFaltas([]);
        console.error("Error al transferir faltas:", error);
        toast.current?.show({
          severity: "warn",
          summary: "Sin resultados",
          detail:
            "No se encontraron faltas ni vacaciones para la nómina y periodo.",
          life: 3000,
        });
      });
  };

  const TransferirFaltas = () => {
    if (listadoFaltas.length === 0) {
      toast.current.show({
        severity: "warn",
        summary: "Advertencia",
        detail: "No hay registros para transferir",
        life: 3000,
      });
      return;
    }
    //console.log("Transferir faltas:", listadoFaltas);
    //return;
    confirmDialog({
      message: "¿Está seguro de transferir los registros seleccionados?",
      header: "Confirmación",
      icon: "pi pi-question-circle",
      accept: async () => {
        try {
          // const response = await axiosPrivate.post(
          //   `/NOM/incidencias/transferir`,
          //   listadoFaltas
          // );
          const response = await axiosPrivate.post(
            "/NOM/incidencias/transferir",
            {
              periodo: `${
                selectedNomina.YearPeriodo
              }-${selectedNomina.PeriodoActual.toString().padStart(2, "0")}`, // o como esté tu periodo
              registros: listadoFaltas,
            }
          );
          //console.log("Transferencia response:", response.data);
          toast.current.show({
            severity: "success",
            summary: "Éxito",
            detail: response.data.msg,
            life: 3000,
          });
          //setListadoFaltas([]); // Limpiar la lista después de la transferencia
        } catch (error) {
          console.error("Error al transferir faltas:", error);
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "No se pudo transferir los registros",
            life: 3000,
          });
        }
      },
    });
  };

  const handleEdit = (empleado) => {
    //console.log("Editar:", empleado);
    // Aquí podrías navegar a un formulario o abrir un modal
    navigate(`/faltas/${empleado.id}`); // ajusta según tu ruta
  };

  const removeRegistro = (excepcion) => {
    confirmDialog({
      message: `¿Estás seguro de quitar el registro de "${excepcion.Nombre}"?`,
      header: "Confirmar remoción",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí, eliminar",
      rejectLabel: "Cancelar",
      accept: async () => {
        try {
          const nuevosDatos = listadoFaltas.filter(
            (d) => d.id !== excepcion.id
          );
          setListadoFaltas(nuevosDatos);
        } catch (error) {
          console.error("Error al eliminar:", error);
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "No se pudo eliminar el registro",
            life: 3000,
          });
        }
      },
    });
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex gap-2">
        <Button
          icon="pi pi-minus-circle"
          className="p-button-rounded p-button-warning p-button-sm"
          onClick={() => removeRegistro(rowData)}
          tooltip="Remover registro"
          //label="Remover"
        />
      </div>
    );
  };
  return (
    <div className="p-m-4">
      <Toast ref={toast} />
      <ConfirmDialog />
      <Card title="Transferencia de incidencias a nómina">
        <div className="mb-3 flex justify-content-between">
          <Button
            label="Regresar"
            icon="pi pi-arrow-left"
            className="p-button-secondary"
            onClick={handleBack}
          />
          <Button
            label="Exportar Excel"
            icon="pi pi-file-excel"
            severity="success"
            onClick={() => exportExcel(listadoFaltas, "Incidencias")}
          />
          <Button
            label="Transferir incidencias"
            icon="pi pi-cog"
            className="p-button-info"
            onClick={() => TransferirFaltas()}
          />
        </div>
        <Toolbar
          className="mb-4"
          left={leftToolbarTemplate}
          //   right={rightToolbarTemplate}
        />
        <DataTable
          ref={dt}
          value={listadoFaltas}
          //   responsiveLayout="scroll"
          paginator
          paginatorTemplate={template2}
          first={first2}
          rows={rows2}
          onPage={onCustomPage2}
          removableSort
          className="p-datatable-sm"
          stripedRows
          globalFilter={globalFilter}
          globalFilterFields={[
            "numero",
            "Nombre",
            "fechas",
            "periodo",
            "usuario",
          ]}
        >
          {dynamicColumns}
          <Column
            body={actionBodyTemplate}
            header="Acciones"
            style={{ minWidth: "10rem" }}
          />
        </DataTable>
      </Card>
    </div>
  );
};

export default IncidenciasTranferencia;
